module.exports = __webpack_public_path__ + "static/topo-theigravidez-62cc3a243de54f104cd8757b29031793.png";